import template from './index.html'
import controller from './controller'

export const vsName = 'partPartTransaction'
export const vsNgType = 'directive'

partPartTransaction.vsName = vsName
partPartTransaction.vsNgType = vsNgType

partPartTransaction.$inject = []
function partPartTransaction() {
  return {
    restrict: 'E',
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: template,
    scope: {
      partTransaction: '=',
      part: '='
    }
  }
}

export default partPartTransaction